import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { Grid, Typography, Button } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { DataGrid } from "@mui/x-data-grid";

import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import DataGridFilters from "SharedComponents/DataGrid/Filters";
import _ from "lodash";

//Services
import usersApi from "Services/GetUsers";
import LocationApi from "Services/Location";

//Modals
import RestrictedLocationUpdateModal from "Pages/Modals/Location/RestrictLocation/Update";
import RestrictedLocationAddModal from "Pages/Modals/Location/RestrictLocation/Create";
import DeleteLocationModal from "Pages/Modals/Location/RestrictLocation/Delete";

const RestrictLocation = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [row, setRow] = useState([]);
  const [pageSize, setPageSize] = useState(5);

  const [RestrictLocationAddModal, setRestrictLocationAddModal] =
    useState(false);

  const [RestrictLocationUpdateModal, setRestrictLocationUpdateModal] =
    useState(false);

  const [locationId, setLocationId] = useState(null);

  //Modals

  const handleOpenUpdateRestrictServiceModal = (row) => {
    //console.log("row?._id ", row?._id);

    setLocationId(row?._id);
    setRestrictLocationUpdateModal(true);
  };

  const handleCloseUpdateRestrictServiceModal = (row) => {
    setLocationId(row?._id);
    setRestrictLocationUpdateModal(false);
    getRestrictLocationList();
  };

  const handleOpenAddRestrictServiceModal = () => {
    setRestrictLocationAddModal(true);
  };

  const handleCloseAddRestrictServiceModal = () => {
    setRestrictLocationAddModal(false);
    getRestrictLocationList();
  };


const [deleteLocationModal, setdeletelocationModal] = useState(false);

    // Location details modal
  const handleOpenDeleteLocation = (row) => {
    setLocationId(row?._id);
    setdeletelocationModal(true);
  };

  const handleCloseDeleteLocation = (row) => {
    setLocationId(row?._id);
    setdeletelocationModal(false);
    getRestrictLocationList();
  };

  // Get Restriction list api
  const getRestrictLocationList = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setRow(res?.data?.data);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    LocationApi.getRestrictedServiceArea().then(onSuccess, onFailure);
  }, []);
  useEffect(() => {
    getRestrictLocationList();
  }, [getRestrictLocationList]);

// Toggle active/inactive status
const handleToggleStatus = (rowData) => {
  dispatch(showLoader("Updating status..."));

  const updatedStatus = !rowData?.isActive;

  const data = {
    isActive: updatedStatus, // 👈 toggle active/inactive
  };
console.log(data);
  const onSuccess = (res) => {
    dispatch(hideLoader());
    dispatch(
      showSnackbar({
        message: res?.data?.message || "Status updated successfully",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
        variant: "success",
      })
    );
    getRestrictLocationList(); // Refresh data
  };

  const onFailure = (err) => {
    dispatch(hideLoader());
    dispatch(
      showSnackbar({
        message: err?.response?.data?.message || "Failed to update status",
        autoHideDuration: 3000,
        anchorOrigin: { vertical: "top", horizontal: "right" },
        variant: "error",
      })
    );
  };

  LocationApi.restrictLocationUpdate(rowData?._id, data).then(onSuccess, onFailure);
};


const formatTime = (hour, minutes, timeFormat) => {
  let formattedHour = hour;
  let period = "";

  if (timeFormat === 12) {
    period = hour >= 12 ? "PM" : "AM";
    formattedHour = hour % 12 === 0 ? 12 : hour % 12; // ✅ this line fixes 0:00 -> 12:00
  } else {
    // if you ever use 24-hour times
    period = hour >= 12 ? "PM" : "AM";
    formattedHour = hour % 12 === 0 ? 12 : hour % 12;
  }

  const formattedMinutes = minutes.toString().padStart(2, "0");
  return `${formattedHour}:${formattedMinutes} ${period}`;
};

  const dataRows = _.map(row || [], (data, index) => {
    // Extracting starting time components
    const startingHour = data?.startingTime?.hour || 0;
    const startingMinutes = data?.startingTime?.minutes || 0;
    const startingSeconds = data?.startingTime?.seconds || 0;
    const startingTimeFormat = data?.startingTime?.timeFormat || 24;

    // Creating startingTime string
    const startingTime = formatTime(
      startingHour,
      startingMinutes,
      startingTimeFormat
    );

    // Extracting ending time components
    const endingHour = data?.endingTime?.hour || 0;
    const endingMinutes = data?.endingTime?.minutes || 0;
    const endingSeconds = data?.endingTime?.seconds || 0;
    const endingTimeFormat = data?.endingTime?.timeFormat || 24;

    // Creating endingTime string
    const endingTime = formatTime(endingHour, endingMinutes, endingTimeFormat);

    return {
      sno: index + 1,
      location: data?.locationId?.locationName,
      country: data?.locationId?.countryId,
      restrictType: data?.restrictionType,
      status:data?.isActive ? "Active" : "inactive",
      startingTime: startingTime,
      endingTime: endingTime,
      row: data,
    };
  });

  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      flex:0.5,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "location",
      headerName: "Location",
        flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.location}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "startingTime",
      headerName: "Starting Time",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">
                {params?.row?.startingTime}
              </Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "endingTime",
      headerName: "Ending Time",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.endingTime}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "restrictType",
      headerName: "Restrict Type",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">
                {params?.row?.restrictType}
              </Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "country",
      headerName: "Country",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.country}</Typography>
            </div>
          </>
        );
      },
    },
{
  field: "status",
  headerName: "Status",
  flex: 1,
  sortable: false,
  disableColumnMenu: true,
  renderCell: (params) => {
    const isActive = params?.row?.row?.isActive;
    return (
      <Button
        variant="contained"
        onClick={() => handleToggleStatus(params?.row?.row)}
        style={{
          backgroundColor: isActive ? "#4caf50" : "#ffcccc", // green or light red
          color: isActive ? "#fff" : "#b30000", // white or dark red text
          padding: "6px 16px",
          borderRadius: "6px",
          textTransform: "capitalize",
          fontWeight: 500,
        }}
      >
        {isActive ? "Active" : "Inactive"}
      </Button>
    );
  },
},
    {
      field: "actions",
      headerName: "Actions",
      flex:1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.iconsWrapper}>
              {/* <section className={classes.deleteIcon}>
                <DeleteOutlineOutlinedIcon />
              </section> */}


        {/* Edit Icon */}
        <section className={classes.editIcon}>
          <EditOutlinedIcon
            onClick={() =>
              handleOpenUpdateRestrictServiceModal(params?.row?.row)
            }
            style={{ cursor: "pointer", color: "#ffffffff" }}
          />
        </section>

        {/* Delete Icon */}
        <section className={classes.deleteIcon}>
          <DeleteOutlineOutlinedIcon
            onClick={() =>
              handleOpenDeleteLocation(params?.row?.row)
            }
            style={{ cursor: "pointer", color: "#ffffffff" }}
          />
        </section>

            </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      <Grid container>
        <Grid item xs={12} md={12} lg={12} xl={12} className={classes.addBtn}>
          <Button
            variant="contained"
            onClick={handleOpenAddRestrictServiceModal}
          >
            Add Restricted Area
          </Button>
        </Grid>
      </Grid>
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <section className={classes.dataGridTable}>
            <DataGrid
              getRowId={(row) => row?.row?._id}
              rows={dataRows}
              columns={columns}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[5, 10, 25, 50]}
              pagination
              autoHeight={true}
              disableSelectionOnClick
              scrollbarSize={4}
              rowHeight={70}
              components={{ Toolbar: DataGridFilters }}
              style={{ padding: "10px", borderRadius: "0px" }}
            />
          </section>
        </Grid>
      </Grid>
      <RestrictedLocationAddModal
        open={RestrictLocationAddModal}
        handleClose={handleCloseAddRestrictServiceModal}
      ></RestrictedLocationAddModal>

      <RestrictedLocationUpdateModal
        open={RestrictLocationUpdateModal}
        handleClose={handleCloseUpdateRestrictServiceModal}
        locationId={locationId}
      />
                  <DeleteLocationModal
                  openDialog={deleteLocationModal}
                  id={locationId}
                  handleClose={handleCloseDeleteLocation}
                ></DeleteLocationModal>
    </>
  );
};

export default RestrictLocation;
